import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import { Tooltip } from "antd";
import React, { useState } from "react";
import {
  FaUserDoctor,
  FaUserLock,
  FaUserNurse,
  FaUserTie,
} from "react-icons/fa6";
import RoleDeleteModal from "../delete-modal/RoleDeleteModal";
import DynamicFormModal from "../../dynamic-modal/DynamicFormModal";
import { useCheckPageComponentAccess } from "@src/hooks/index";

interface RoleDetailsCardProps {
  profile: any;
}

const RoleDetailsCard: React.FC<RoleDetailsCardProps> = ({ profile }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [mutationType, setMutationType] = useState<"add" | "edit" | undefined>(
    undefined
  );
  const [formValues, setFormValues] = useState({});

  const deleteModalOpen = () => {
    setModalOpen(true);
  };

  const editModalOpen = () => {
    setModalVisible(true);
    setMutationType("edit");
    setFormValues(profile);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const roleName = profile?.systemUser?.roleList?.[0]?.name || "";

  const getRoleBadge = () => {
    switch (roleName) {
      case "Nurse":
        return { icon: <FaUserNurse />, color: "#38a169", bg: "#e6f7ed" };
      case "Doctor":
        return { icon: <FaUserDoctor />, color: "#3182ce", bg: "#e8f0fe" };
      case "User":
        return { icon: <FaUserTie />, color: "#d53f8c", bg: "#fef3f8" };
      case "ClinicalAdmin":
        return { icon: <FaUserLock />, color: "#e53e3e", bg: "#fef2f2" };
      default:
        return { icon: <FaUserLock />, color: "#805ad5", bg: "#f0e6f6" };
    }
  };

  const badge = getRoleBadge();

  return (
    <React.Fragment>
      <div className="role-card">
        <div className="role-card-gradient-bar" />
        <div className="role-badge-row">
          <div
            className="role-type-badge"
            style={{ color: badge.color, backgroundColor: badge.bg }}
          >
            {badge.icon}
            <span>{roleName || "Role"}</span>
          </div>
        </div>
        <div className="role-card-body">
          <div className="role-avatar-wrap">
            <img
              src={profile?.file?.url || profile?.photo || USER_PROFILE}
              className="role-avatar-img"
              alt="Profile"
            />
          </div>
          <div className="role-name">{profile.name}</div>
          <div className="role-code">{profile.code}</div>
          <div className="role-org">{profile?.organization?.name}</div>
        </div>
        <div className="role-card-footer">
          {useCheckPageComponentAccess("delete_role_action") && (
            <Tooltip title="Delete">
              <button
                className="role-action-btn role-action-red"
                onClick={deleteModalOpen}
              >
                <AiFillDelete />
              </button>
            </Tooltip>
          )}
          {useCheckPageComponentAccess("edit_role_action") && (
            <Tooltip title="Edit">
              <button
                className="role-action-btn role-action-blue"
                onClick={editModalOpen}
              >
                <AiFillEdit />
              </button>
            </Tooltip>
          )}
        </div>
      </div>
      <RoleDeleteModal
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
        profile={profile}
      />
      <DynamicFormModal
        visible={modalVisible}
        onCancel={handleCancel}
        formType="roles"
        title={`Edit ${roleName}`}
        mutationType={mutationType}
        setModalVisible={setModalVisible}
        item={profile}
        formValues={formValues}
      />
    </React.Fragment>
  );
};

export default RoleDetailsCard;
